import gql from 'graphql-tag';

export interface Category {
  id: string;
  canonicalName: string;
}

export interface Product {
  id: string;
  name: string;
  category: Category;
}

export interface Entry {
  id: string;
  product: Product;
}

export interface Task {
  id: string;
  entries: Entry[];
}

export const getTask = gql`
query($id: ID!) {
  task(id: $id) {
    id
    entries {
      id
      product {
        id
        name
        category {
          id
          canonicalName
        }
      }
    }
  }
}
`;
